/*global $ */
import ko from 'knockout';

export function registerComponent() {
  ko.components.register('duration-picker', {
    template: { element: 'duration-picker-template' },
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new SearchDurationPickerViewModel(params, componentInfo);
      },
    },
  });
}

function SearchDurationPickerViewModel(params, componentInfo) {
  var monthNames = ['jan.', 'feb.', 'maa.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];

  var self = this;
  var period = params.Period;

  self.arrival = period.Arrival;
  self.duration = period.Duration;
  self.durationCorrection = period.DurationCorrection;
  self.durationCorrectionVisible = period.DurationCorrectionVisible;
  self.fieldNameDuration = params.FieldNameDuration;
  self.fieldNameDurationCorrection = params.FieldNameDurationCorrection;
  self.fieldNameDurationCorrectionVisible = params.FieldNameDurationCorrectionVisible;
  self.content = ko.observable();
  self.durations = [];
  self.recommendedDurations = [];

  params.Durations.forEach((d) => {
    self.durations.push(new Duration(d.value, d.text, period.Arrival, period.Duration));
  });

  ['14', '7', '4', '3', '5'].forEach((r) => {
    var d = params.Durations.find(du => du.value == r);
    self.recommendedDurations.push(new Duration(d.value, d.text, period.Arrival, period.Duration));
  });

  period.Arrival.subscribe(setContent);
  period.Duration.subscribe(setContent);

  setContent();

  self.select = function (e) {
    self.duration(e.value);

    $(componentInfo.element).trigger('periodselected');
  };

  function setContent() {
    var duration = parseDuration(period.Duration());
    if (duration) {
      var d = self.durations.find(d => d.value == period.Duration());
      var arrival = parseArrival(period.Arrival());
      if (arrival) {
        var departure = addDays(arrival, duration);
        self.content(d.text + ' (' + departure.getDate() + ' ' + monthNames[departure.getMonth()] + ')');
      } else {
        self.content(d.text);
      }
    } else {
      self.content('&nbsp;');
    }
  }

  function parseArrival(arrival) {
    var parts = arrival.split(/[\s\-./]+/);
    if (parts.length !== 3) {
      return null;
    } else {
      return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
    }
  }

  function parseDuration(duration) {
    return parseInt(duration);
  }

  function addDays(date, days) {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + days);
    return newDate;
  }

  function Duration(value, text, arrival, selectedDuration) {
    var duration = parseDuration(value);
    this.value = value;
    this.text = text;

    this.selected = ko.pureComputed(function () {
      return selectedDuration() === value;
    }, this);

    this.departure = ko.pureComputed(function () {
      if (arrival()) {
        var departure = addDays(parseArrival(arrival()), duration);
        return ' (' + departure.getDate() + ' ' + monthNames[departure.getMonth()] + ')';
      } else {
        return '';
      }
    }, this);
  }
}
